import React from "react";
import { Col, Row, Typography,Button, Form, Input } from 'antd';
const { Title, Paragraph } = Typography;
const { TextArea } = Input;

const FormSection = () => {
  // const [inpValue, setinpValue] = useState({
  //   name: "",
  //   email: "",
  //   subject: "",
  //   message: ""
  // });
  // const changeValue = (event) => {
  //   const name = event.target.name;
  //   const value = event.target.value;
  //   setinpValue({ ...inpValue, [name]: value });

  // }
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   setinpValue({
  //     name: '',
  //     email: '',
  //     subject: '',
  //     message: '',
  //   });
  //   console.log(inpValue);
  // }

  return (
    <section className="formsection">
      <div className="container">
        <Row>
          <Col sm={24} md={12} lg={14}>
            <div className="form-inner">
              <Title level={2} className="sub-heading text-center">Ask us anything</Title>
              <Paragraph className="form-para text-center mb-5">If you want us to help you became your own innner hero send us a massage</Paragraph>
              <Form>
                <Form.Item
                  name="name"
                  rules={[{ required: true, message: 'Please input your name!' }]}
                >
                  <Input placeholder="Name"  className="form-control"/>
                </Form.Item>
                <Form.Item
                  name="email"
                  rules={[{ required: true, message: 'Please input your email!' }]}
                >
                  <Input placeholder="Email"  className="form-control"/>
                </Form.Item>
                <Form.Item
                  name="subject"
                  rules={[{ required: true, message: 'Please input your subject!' }]}
                >
                  <Input placeholder="Subject"  className="form-control"/>
                </Form.Item>
                <Form.Item
                  name="massage"
                  rules={[{ required: true, message: 'Please input your massage!' }]}
                >
                  <TextArea  placeholder="Massage"  className="form-control"/>
                </Form.Item>
                <Form.Item>
                  <Button type="primary" className="primary-btn" htmlType="submit">Take your first steps</Button>
                </Form.Item>
              </Form>
            </div>
          </Col>
          <Col className="form-content" sm={24} md={12} lg={10}>
            <Title level={4} className="form-heading mb-4">Understand VeChain</Title>
            <Paragraph className="pt-3 pb-5 form-para">Learn which areas of your business can be improved with vechain.energy</Paragraph>
            <Title level={4} className="form-heading mb-4">Learn to develop efficiently</Title>
            <Paragraph className="pt-3 pb-5 form-para">Step by step learning soo we relieve you of your web headache</Paragraph>
            <Title level={4} className="form-heading mb-4">Implement Easy</Title>
            <Paragraph className="pt-3 pb-5 form-para">Complies to the Connex-Standard. Configure with just one line of code.</Paragraph>
          </Col>
        </Row>
      </div>
    </section>
  )
}
export default FormSection;